<script lang="ts">
  import { SearchState } from "../../services/search-service";

  let datasetId = null;
  let showButton = false;
  let isLoading = true;

  SearchState.subscribe((search) => {
    datasetId = search.params.get("datasetId");
    showButton = !!datasetId;
    isLoading = false;
  })

  function handleBack() {
    if (!datasetId) return;

    const newParams = $SearchState.params;
    newParams.delete("datasetId");
    // TODO: This probably just wants to be changed to an <a> tag
    window.location.href = `../datasets/${datasetId}?${newParams}`;
  }
</script>

{#if !isLoading && showButton}
  <button class="btn btn-secondary" on:click={handleBack}>
    <i class="bi bi-arrow-left me-1"></i> Back to Dataset
  </button>
{/if}
